﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import TinkPage from "./Component";

//-------------------------------------------------------------------------------------
// Exports
//-------------------------------------------------------------------------------------

export default TinkPage;
